// extracted by mini-css-extract-plugin
export default {"form":"styles_form__3zBmE","input":"styles_input__+ObWK"};